import { IntegrationFlowAuthenticationKind } from "client/Api/IntegrationBuilder/integrationBuilderAuthentication";
import { IFormHandler } from "client/Forms";
import { ReactElement } from "react";
import { AuthenticationFormData } from "../common";
import { never } from "client_legacy/ndaw/errors";
import { ApiKeySettings } from "./Settings/ApiKeySettings";
import { OAuth2Settings } from "./Settings/OAuth2Settings";
import { BasicAuthSettings } from "./Settings/BasicAuthSettings";
import { ClientCertificateSettings } from "./Settings/ClientCertificateSettings";
import { AfasSettings } from "./Settings/AfasSettings";

export type AuthenticationSettingsProps = {
	attachable: IFormHandler<AuthenticationFormData>;
	isNew: boolean;
	oAuth2RedirectUrl: string | null;
};

export const AuthenticationSettings = (props: AuthenticationSettingsProps): ReactElement => {
	const {
		attachable,
		isNew,
		oAuth2RedirectUrl
	} = props;

	switch (attachable.value.kind) {
		case IntegrationFlowAuthenticationKind.ApiKey:
			return (
				<ApiKeySettings
					attachable={attachable.for("apiKey")}
				/>
			);
		case IntegrationFlowAuthenticationKind.OAuth2:
			return (
				<OAuth2Settings
					attachable={attachable.for("oAuth2")}
					isNew={isNew}
					redirectUrl={oAuth2RedirectUrl}
				/>
			);
		case IntegrationFlowAuthenticationKind.Basic:
			return (
				<BasicAuthSettings />
			);
		case IntegrationFlowAuthenticationKind.ClientCertificate:
			return (
				<ClientCertificateSettings
					attachable={attachable.for("clientCertificate")}
					isNew={isNew}
				/>
			);
		case IntegrationFlowAuthenticationKind.Afas:
			return (
				<AfasSettings
					attachable={attachable.for("afas")}
					isNew={isNew}
				/>
			);
		default:
			never(attachable.value.kind);
	}
};
AuthenticationSettings.displayName = "AuthenticationSettings";
